import { IconProps } from '.'

export function WarningIcon({
  width = 18,
  height = 18,
  color = 'currentColor',
  ...props
}: IconProps): JSX.Element {
  return (
    <svg
      viewBox='0 0 24 24'
      focusable='false'
      width={width}
      height={height}
      fill={color}
      aria-hidden
      role='img'
      {...props}
    >
      <path
        fill={color}
        d='M4.47012 17.5038H19.5301C21.0701 17.5038 22.0301 15.8338 21.2601 14.5038L13.7301 1.49378C12.9601 0.163777 11.0401 0.163777 10.2701 1.49378L2.74012 14.5038C1.97012 15.8338 2.93012 17.5038 4.47012 17.5038ZM12.0001 10.5038C11.4501 10.5038 11.0001 10.0538 11.0001 9.50378V7.50378C11.0001 6.95378 11.4501 6.50378 12.0001 6.50378C12.5501 6.50378 13.0001 6.95378 13.0001 7.50378V9.50378C13.0001 10.0538 12.5501 10.5038 12.0001 10.5038ZM13.0001 14.5038H11.0001V12.5038H13.0001V14.5038Z'
      ></path>
    </svg>
  )
}
